<app-breadcrumb [title]="'system settings' | translate" [items]="['security' | translate]" [active_item]="'system settings' | translate"></app-breadcrumb>

<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card" *ngIf="!isLoading">
                <!--<div class="card-header d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">{{ 'system settings'|translate }}</h5>
                    <div class="card-options">
                        <a class="card-options-collapse" href="javascript:void(0)" data-bs-toggle="card-collapse">
                            <i class="fe fe-chevron-up"></i>
                        </a>
                    </div>
                </div>-->

                <div class="card-body">
                    <form [formGroup]="systemSettingsForm" (ngSubmit)="onFormSubmit()" id="ngForm">
                        <!-- Compact Settings Grid -->
                        <div class="row g-4">
                            <!-- Company Settings Column -->
                            <div class="col-md-6">
                                <div class="settings-card">
                                    <h6 class="settings-card-title">
                                        <i class="fas fa-building me-2 text-primary"></i>
                                        {{ 'company' | translate }}
                                    </h6>
                                    <div class="settings-item">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="singleCompany" formControlName="isSingleCompany">
                                            <label class="form-check-label" for="singleCompany">
                                                {{ 'single company mode' | translate }}
                                            </label>
                                        </div>
                                        <div class="setting-explanation alert alert-light mt-2 p-2" *ngIf="systemSettingsForm.get('isSingleCompany')?.value">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'Restricts the system to a single company entity, affecting user permissions and data visibility across all modules.' | translate }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="settings-item">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="multipleBranches" formControlName="isBranches">
                                            <label class="form-check-label" for="multipleBranches">
                                                {{ 'multiple branches' | translate }}
                                            </label>
                                        </div>
                                        <div class="setting-explanation alert alert-light mt-2 p-2" *ngIf="systemSettingsForm.get('isBranches')?.value">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'Allows management of different locations independently while maintaining centralized control. Each branch maintains its own inventory and reporting.' | translate }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Budget Settings Column -->
                            <div class="col-md-6">
                                <div class="settings-card">
                                    <h6 class="settings-card-title">
                                        <i class="fas fa-calculator me-2 text-info"></i>
                                        {{ 'budget' | translate }}
                                    </h6>
                                    <div class="settings-item">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="autoBudget" formControlName="isBudgetAutomatic">
                                            <label class="form-check-label" for="autoBudget">
                                                {{ 'automatic budget' | translate }}
                                            </label>
                                        </div>
                                        <div class="setting-explanation alert alert-light mt-2 p-2" *ngIf="systemSettingsForm.get('isBudgetAutomatic')?.value">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'Automatically calculates and allocates budgets based on historical data and predefined rules.' | translate }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Price Settings Column -->
                            <div class="col-md-6">
                                <div class="settings-card">
                                    <h6 class="settings-card-title">
                                        <i class="fas fa-calculator me-2 text-info"></i>
                                        {{ 'sale' | translate }}
                                    </h6>
                                    <div class="settings-item">
                                        <div class="mb-3 row">
                                            <label class="col-sm-2">{{ 'price list'|translate }}</label>
                                            <div class="col-sm-6">
                                                <ng-select
                                                        [items]="defaultPriceLists"
                                                        bindLabel="name"
                                                        bindValue="id"
                                                        placeholder="{{ 'choose price list'|translate }}"
                                                        formControlName="defaultPriceList"
                                                        [(ngModel)]="defaultPriceListSelected">
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="settings-item">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="autoPrice" formControlName="isSalePriceWithFormula">
                                            <label class="form-check-label" for="autoBudget">
                                                {{ 'sale price With formula' | translate }}
                                            </label>
                                        </div>
                                        <div class="setting-explanation alert alert-light mt-2 p-2" *ngIf="systemSettingsForm.get('isSalePriceWithFormula')?.value">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'Automatically calculates and allocates price based on formula and predefined rules.' | translate }}
                                            </small>
                                        </div>
                                    </div>
                                        <div class="settings-item">
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="autoPricePu" formControlName="isSalePriceWithPu">
                                                <label class="form-check-label" for="inventoryZeroing">
                                                    {{ 'sale Price With Pu' | translate }}
                                                </label>
                                            </div>
                                            <div class="setting-explanation alert alert-light mt-2 p-2" *ngIf="systemSettingsForm.get('isSalePriceWithPu')?.value">
                                                <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                    {{ 'Automatically calculates and allocates price based on Pu and quantity.' | translate }}
                                                </small>
                                            </div>
                                        </div>
                                        <div class="settings-item">
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="isPointsUse" formControlName="isPointsUse">
                                                <label class="form-check-label" for="inventoryZeroing">
                                                    {{ 'use points' | translate }}
                                                </label>
                                            </div>
                                            <div class="setting-explanation alert alert-light mt-2 p-2" *ngIf="systemSettingsForm.get('isPointsUse')?.value">
                                                <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                    {{ 'Points will be use in the system why making invoice.' | translate }}
                                                </small>
                                            </div>
                                        </div>

                                </div>
                            </div>

                            <!-- Inventory Settings Column -->
                            <div class="col-md-6">
                                <div class="settings-card">
                                    <h6 class="settings-card-title">
                                        <i class="fas fa-warehouse me-2 text-success"></i>
                                        {{ 'inventory' | translate }}
                                    </h6>
                                    <div class="settings-item">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="cumulatedZone" formControlName="isCumulatedZoneQuantity">
                                            <label class="form-check-label" for="cumulatedZone">
                                                {{ 'cumulated zone quantity' | translate }}
                                            </label>
                                        </div>
                                        <div class="setting-explanation alert alert-light mt-2 p-2" *ngIf="systemSettingsForm.get('isCumulatedZoneQuantity')?.value">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'Shows total quantities across all zones rather than per-zone quantities in inventory reports.' | translate }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="settings-item">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="inventoryZeroing" formControlName="isInventoryZeroing">
                                            <label class="form-check-label" for="inventoryZeroing">
                                                {{ 'inventory zeroing' | translate }}
                                            </label>
                                        </div>
                                        <div class="setting-explanation alert alert-light mt-2 p-2" *ngIf="systemSettingsForm.get('isInventoryZeroing')?.value">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'Allows inventory quantities to be reset to zero during stock adjustments when needed.' | translate }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="settings-item">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="updateInventory" formControlName="isUpdatingInventoryQuantities">
                                            <label class="form-check-label" for="updateInventory">
                                                {{ 'update inventory quantities' | translate }}
                                            </label>
                                        </div>
                                        <div class="setting-explanation alert alert-light mt-2 p-2" *ngIf="systemSettingsForm.get('isUpdatingInventoryQuantities')?.value">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'Enables real-time updates of inventory quantities across all locations when transactions occur.' | translate }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- HR Settings Column -->
                            <div class="col-md-6">
                                <div class="settings-card">
                                    <h6 class="settings-card-title">
                                        <i class="fas fa-users me-2 text-warning"></i>
                                        {{ 'hr_payroll' | translate }}
                                    </h6>
                                    <div class="settings-item">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="pitGrossSalary"
                                                   formControlName="isPitGrossSalaryPercentage">
                                            <label class="form-check-label" for="pitGrossSalary">
                                                {{ 'PIT gross salary percentage' | translate }}
                                            </label>
                                        </div>
                                        <div class="setting-explanation alert alert-light mt-2 p-2" *ngIf="systemSettingsForm.get('isPitGrossSalaryPercentage')?.value">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'Enables automatic calculation of Personal Income Tax as a percentage of gross taxable salary. The percentage value becomes mandatory for payroll calculations.' | translate }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="settings-item" *ngIf="systemSettingsForm.get('isPitGrossSalaryPercentage')?.value">
                                        <label for="pitPercentage" class="form-label">
                                            {{ 'PIT gross salary percentage' | translate }}
                                            <span class="text-danger">*</span>
                                        </label>
                                        <input type="number" class="form-control" id="pitPercentage"
                                               formControlName="pitGrossSalaryPercentage" step="0.01" min="0" max="100">
                                        <div *ngIf="systemSettingsForm.get('pitGrossSalaryPercentage')?.invalid &&
                                           (systemSettingsForm.get('pitGrossSalaryPercentage')?.dirty ||
                                            systemSettingsForm.get('pitGrossSalaryPercentage')?.touched)"
                                             class="text-danger small mt-1">
                                            <div *ngIf="systemSettingsForm.get('pitGrossSalaryPercentage')?.errors?.['required']">
                                                {{ 'percentage is required' | translate }}
                                            </div>
                                            <div *ngIf="systemSettingsForm.get('pitGrossSalaryPercentage')?.errors?.['min']">
                                                {{ 'percentage must be at least 0' | translate }}
                                            </div>
                                            <div *ngIf="systemSettingsForm.get('pitGrossSalaryPercentage')?.errors?.['max']">
                                                {{ 'percentage cannot exceed 100' | translate }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="settings-item">
                                        <label for="professionalExpense" class="form-label">
                                            {{ 'Professional Expense Deduction' | translate }}
                                        </label>
                                        <input type="number" class="form-control" id="professionalExpense"
                                               formControlName="professionalExpense" step="0.01" min="0">
                                        <div class="setting-explanation alert alert-light mt-2 p-2">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'Standard professional expense deduction amount applied to taxable income.' | translate }}
                                            </small>
                                        </div>
                                    </div>

                                    <div class="settings-item">
                                        <label for="taxExemptThreshold" class="form-label">
                                            {{ 'Tax Exempt Threshold' | translate }}
                                        </label>
                                        <input type="number" class="form-control" id="taxExemptThreshold"
                                               formControlName="taxExemptThreshold" step="0.01" min="0">
                                        <div class="setting-explanation alert alert-light mt-2 p-2">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'Income threshold below which no taxes are applied.' | translate }}
                                            </small>
                                        </div>
                                    </div>

                                    <div class="settings-item">
                                        <label for="maxProfessionalExpenseAmount" class="form-label">
                                            {{ 'Max Professional Expense Deduction' | translate }}
                                        </label>
                                        <input type="number" class="form-control" id="maxProfessionalExpenseAmount"
                                               formControlName="maxProfessionalExpenseAmount" step="1" min="0">
                                        <div class="setting-explanation alert alert-light mt-2 p-2">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'The statutory ceiling for professional expense deductions. Many tax authorities limit this amount to prevent excessive tax benefits, particularly for high-income earners. Set this value according to your local tax regulations.' | translate }}
                                            </small>
                                        </div>
                                    </div>

                                    <div class="settings-item">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="scaleRange2021"
                                                   formControlName="isScaleRange2021">
                                            <label class="form-check-label" for="scaleRange2021">
                                                {{ 'Use 2021 Scale Range' | translate }}
                                            </label>
                                        </div>
                                        <div class="setting-explanation alert alert-light mt-2 p-2" *ngIf="systemSettingsForm.get('isScaleRange2021')?.value">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'When enabled, the system will use the 2021 tax scale range calculations instead of the current standard scale.' | translate }}
                                            </small>
                                        </div>
                                    </div>
									
									<div class="settings-item">
                                        <label for="maxProfessionalExpenseAmount" class="form-label">
                                            {{ 'contract notice period' | translate }}
                                        </label>
                                        <input type="number" class="form-control" id="contractNoticePeriod"
                                               formControlName="contractNoticePeriod" step="1" min="0">
                                        <div class="setting-explanation alert alert-light mt-2 p-2">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'contract notice period (in day).' | translate }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="settings-item">
                                        <label for="maxProfessionalExpenseAmount" class="form-label">
                                            {{ 'trial duration' | translate }}
                                        </label>
                                        <input type="number" class="form-control" id="trialDuration"
                                               formControlName="trialDuration" step="1" min="0">
                                        <div class="setting-explanation alert alert-light mt-2 p-2">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'trial duration (in month).' | translate }}
                                            </small>
                                        </div>
                                    </div>

                                    <div class="settings-item">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="payrollAllowPartialPayment"
                                                   formControlName="payrollAllowPartialPayment">
                                            <label class="form-check-label" for="payrollAllowPartialPayment">
                                                {{ 'allow partial payroll payment' | translate }}
                                            </label>
                                        </div>
                                        <div class="setting-explanation alert alert-light mt-2 p-2" *ngIf="systemSettingsForm.get('payrollAllowPartialPayment')?.value">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'Allows payroll payment even if some employees are excluded or missing bank accounts.' | translate }}
                                            </small>
                                        </div>
                                    </div>

                                    <div class="settings-item">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="payrollAllowMissingBankAccount"
                                                   formControlName="payrollAllowMissingBankAccount">
                                            <label class="form-check-label" for="payrollAllowMissingBankAccount">
                                                {{ 'allow missing bank account' | translate }}
                                            </label>
                                        </div>
                                        <div class="setting-explanation alert alert-light mt-2 p-2" *ngIf="systemSettingsForm.get('payrollAllowMissingBankAccount')?.value">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'Allows payroll payment to proceed even if some employees have no bank account.' | translate }}
                                            </small>
                                        </div>
                                    </div>

                                    <div class="settings-item">
                                        <label for="payrollPaymentLetterMessage" class="form-label">
                                            {{ 'payroll payment letter message' | translate }}
                                        </label>
                                        <textarea
                                            class="form-control"
                                            id="payrollPaymentLetterMessage"
                                            formControlName="payrollPaymentLetterMessage"
                                            rows="5"></textarea>
                                        <div class="setting-explanation alert alert-light mt-2 p-2">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'payroll payment letter message help' | translate }}
                                            </small>
                                        </div>
                                    </div>
									
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="card-footer bg-transparent border-top-0 text-end">
                    <button type="button" class="btn btn-outline-secondary me-2" routerLink="/dashboard/security">
                        <i class="fas fa-times me-2"></i>{{ 'cancel'|translate }}
                    </button>
                    <button form="ngForm" type="submit" class="btn btn-primary" [disabled]="saving">
                        <i class="fas fa-save me-2"></i>
                        <span *ngIf="!saving">{{data ? (update | translate) : (create | translate)}}</span>
                        <span *ngIf="saving">{{ "submitting" | translate }}...</span>
                    </button>
                </div>
            </div>

            <!-- Loading State -->
            <div *ngIf="isLoading" class="card">
                <div class="card-body text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-3 mb-0">{{ 'loading settings' | translate }}</p>
                </div>
            </div>
        </div>
    </div>
</div>
